import 'whatwg-fetch';
import moment from "moment"
import Axios from "axios";
import BetterJs from '@/common/BetterJs';
import { IServiceInfo } from "./statement";
import { JsonHelper, EventDriver } from '@/common/Utils';

/** 数据请求失败是重新请求的次数 */
const RELOADCOUNT = 5
const TIMEOUT = 30000

export enum ServiceType {
  Get = 1,
  Post
}

/**
* 执行服务错误处理级别枚举
*/
export enum ServiceErrorLevelEnum {
  /**
   * 不处理任何异常
   */
  notHandling = 1,
  /**
   * 只处理所有请求过程中的环境异常
   */
  fail = 2,
  /**
   * 只处理所有后端反馈异常
   */
  error = 3,
  /**
   * 处理各种异常
   */
  allError = 4
}

export async function getConfig () {
  window.lockSubmit = false;
  let res = await Axios.get<BaseConfig>('/config.json')
  window.baseConfig = res.data;
  if (window.baseConfig.currentUser) {
    const userName= sessionStorage.getItem("userName");
    const userId= sessionStorage.getItem("userId");
    window.baseConfig.currentUser.name = userName || '' 
    window.baseConfig.currentUser.userid = userId || '' 
  }
  if (!window.baseConfig.development) {
    BetterJs.init({
      sendError: (error) => {
        Service.writeLog(error)
      }
    })
  }
  return
}

function _toParamString(val) {
  if (val === null || val === undefined) {
    return null;
  }
  switch (typeof val) {
    case "string":
      return val;
    case "boolean":
      return val ? "true" : "false";
    case "number":
      return val.toString();
    default:
      if (moment.isDate(val)) {
          return moment(val).format("yyyy-MM-dd HH:mm:ss");
      }
      if (val.data && val.data instanceof Blob
          && typeof (val.fileName) == "string") {
          return val;
      }
      if (typeof val === "object") {
        for (var key in val) {
          typeof val[key] === "object" && (val[key] = JsonHelper.toJson(val[key]))
        }
      }
      return JsonHelper.toJson(val);
  }
}
export class Utility {
  /**
  * 异常处理.如果是"UserException"异常,则会直接弹出异常信息;否则会写入异常日志,并弹出"操作失败，请关闭重试！"
  * @param ex 异常对象
  */
  static dispose(ex, rejct = (ex) => {}) {
    if (!ex) { return; }
    switch (ex.name) {
      case "PassException":
        return;
      case "BusinessException":
        switch (ex.type) {
          case "ReferencedDataException":
            {
              var datas = ex.referencedDatas;
              if (datas.length > 5) {
                datas[5] = "等";
              }
              ex.success = false
              ex.message = "被使用的数据：" + datas.join("，") + ex.message
              rejct(ex)
            }
            break;
          default:
            ex.success = false
            rejct(ex)
            break;
        }
        break;
      case "RightsException":
      case "SystemException":
      case "AuthorizationException":
      case "ClientDisposeException":
      case "OpenDBConnectionException":
        ex.success = false
        rejct(ex)
        break;
      default:
      let message = ex + ''
        if (message.search('Network request failed')) {
          let data = {
            success: false,
            message: '网络请求失败，错误码：704'
          }
          rejct(data);
        } else {
          let data = {
            success: false,
            message
          }
          rejct(data);
        }
        break;
    }
  }
}
export class Service {
  /**
   * 执行指定的服务
   * @param service 要执行的服务
  */
  private static _executeService<T>(service: IServiceInfo) {
    return new Promise<T>((resolve, rejct) => {
      let formData;
      let isFormData = false;
      let handlingErrorLevel = service.handlingErrorLevel || ServiceErrorLevelEnum.allError;
      if (service.params) {
        if (service.params instanceof FormData) {
          formData = service.params;
          isFormData = true;
        } else {
          try {
            formData = "";
            for (var key in service.params) {
              if (formData) {
                  formData += "&";
              }
              formData += key + '=' + _toParamString(service.params[key]);
            }
          }
          catch (ex) {
            if (handlingErrorLevel >= ServiceErrorLevelEnum.fail) {
              console.warn('FormatError')
              Utility.dispose(ex);
              console.error('FormData format error: ' + ex);
            } else {
              rejct({
                type: 'FormatError',
                name: '参数格式化出错，请检查参数格式',
                message: ex
              });
            }
          }
        }
      }
      var headers = new Headers({
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json'
      });
      if (!isFormData) {
        headers['Content-Type'] = 'application/x-www-form-urlencoded';
      }

      Promise.race([
        fetch(window.baseConfig.host + service.name, {
          method: "POST",
          cache: "no-cache",
          credentials: "include",
          headers: headers,
          body: formData
        }),
        new Promise<null>(function(resolve,reject){
          setTimeout(()=> {
            let result = {
              data: {
                success: false,
                message: '网络请求超时啦～'
              }
            }
            reject(result.data);
          },TIMEOUT)
        })
      ]).then(response => {
        // response 有可能为null
        if (response) {
          if (response.status >= 200 && response.status < 300) {
            window.baseConfig.development && console.log(response);
            return response.json();
          }
          else {
            var error = new Error(response.statusText);
            error.name = "RequestServiceException";
            error['status'] = response.status;
            throw error;
          }
        } else {
          var error = new Error('response is null');
          error.name = "RequestNullException";
          throw error;
        }
        
      }).then((result) => {
          if(service.name === "/anonymity/writelog"){
            return;
          }
          var ex = result.e;
          if (ex) {
            if (ex.name === "BusinessException") {
              if (handlingErrorLevel >= ServiceErrorLevelEnum.allError) {
                Utility.dispose(ex);
              }
            }
            else if (handlingErrorLevel >= ServiceErrorLevelEnum.allError) {
              Utility.dispose(ex);
            }
            rejct(ex);
          }
          else {
            // result.data 有可能为null
            if (result.data) {
              if (result.data.success === false) {
                console.warn(result)
                rejct(result.data);
              } else {
                resolve(result.data);
              }
            } else {
              // result.data = {
              //   success: false,
              //   message: '网络请求失败，错误码：404'
              // }
              // rejct(result.data);
              result.data = {
                success: true,
                message: 'success'
              }
              resolve(result.data);
            }
          }
      }).catch(ex => {
          if(service.name === "/anonymity/writelog"){
            return;
          }
          if (handlingErrorLevel >= ServiceErrorLevelEnum.fail) {
            console.warn('http catch')
            Utility.dispose(ex, rejct);
          } else {
            rejct(ex);
          }
      });
    })
  }
  /**
   * 写日志
   * @param data 日志数据
   */
  static async writeLog(data) {
    // 把日志数据上传到服务器
    window.baseConfig.development && console.log(JsonHelper.toJson(data));
    // Service._executeService({
    //   name: "/anonymity/writelog",
    //   params: data
    // })
  }
  /**
   * 执行指定的服务
   * @param service 要执行的服务
   * @param type 服务的类型
   */
  static executeService<T>(service: IServiceInfo, type: ServiceType = ServiceType.Get) {
    // return Service._executeService<T>(service)
    return new Promise<T>((resolve, rejct) => {
      let reloading = RELOADCOUNT
       let execute = () => {
        Service._executeService<T>(service).then(res => {
          resolve(res)
          type === ServiceType.Get && EventDriver.send("networkError", false, () => {});

          // type === ServiceType.Get && EventDriver.send("networkError", true, execute);
        }).catch(err => {
          if (err.success === false) { rejct(err); return }
          if (err.name === 'RequestServiceException') {
            if (err.status === 408 || err.status === 503 || err.status === 504) {
              if (reloading > 0) {
                window.baseConfig.development && console.log('数据请求失败，重新请求，请求计数：' + reloading);
                execute()
                reloading--
              } else {
                type === ServiceType.Get && EventDriver.send("networkError", true, execute);
                rejct(err)
              }
            } else rejct(err)
          } else rejct(err)
        })
       }
       execute()
    })
  }
}


// WEBPACK FOOTER //
// ./src/common/Service/index.ts